import type { IndexSignature } from "@clintonelec/typescriptutils";
import { POST, GET, PATCH, DELETE } from "Data/API/Request";
import { serializeJsonApiData, deserializeJsonApiData } from "Data/Utils/JsonApi";
import type { DataPage, Hostname, WithApiData, ApiHostname } from "Interfaces";
import { ResourceType } from "Interfaces";

export const createHostname = (hostname: Hostname, token: string) => {
	const serializedPayload = serializeJsonApiData(ResourceType.HOSTNAMES, hostname);

	return POST<ApiHostname>("hostnames", serializedPayload, token).then((response: WithApiData<ApiHostname>) => {
		return deserializeJsonApiData<ApiHostname>(response);
	});
};

export const updateHostname = (hostname: ApiHostname, token: string) => {
	const { id } = hostname;
	const serializedPayload = serializeJsonApiData(ResourceType.HOSTNAMES, hostname);

	return PATCH<ApiHostname>(`hostnames/${ id }`, token, serializedPayload)
		.then((response: WithApiData<ApiHostname>) => {
			return deserializeJsonApiData<ApiHostname>(response);
		});
};

export const fetchHostname = (id: string, token: string) => {
	return GET<ApiHostname>(`hostnames/${ id }`, token).then((response: WithApiData<ApiHostname>) => {
		return deserializeJsonApiData<ApiHostname>(response);
	});
};

export const fetchHostnames = (filter: IndexSignature<string | number>, token: string) => {
	return GET<ApiHostname[]>("hostnames", token, filter).then((response: WithApiData<ApiHostname[]>) => {
		return deserializeJsonApiData<ApiHostname[]>(response).then((hosts: ApiHostname[]) => {
			return {
				...response,
				data: hosts
			} as DataPage<ApiHostname>;
		});
	});
};

export const deleteHostname = (id: string, token: string) => {
	return DELETE(`hostnames/${ id }`, token);
};
